import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_56bb234a from 'nuxt_plugin_plugin_56bb234a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_middleware_6dbf44f5 from 'nuxt_plugin_middleware_6dbf44f5' // Source: ./middleware.js (mode: 'all')
import nuxt_plugin_store_4aa841a6 from 'nuxt_plugin_store_4aa841a6' // Source: ./store.js (mode: 'all')
import nuxt_plugin_appplugin_d06cc13e from 'nuxt_plugin_appplugin_d06cc13e' // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_1833388e from 'nuxt_plugin_configplugin_1833388e' // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_ad41c2ae from 'nuxt_plugin_nitrobridgeserver_ad41c2ae' // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_57ea5f31 from 'nuxt_plugin_nitrobridgeclient_57ea5f31' // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_image_9ddbf228 from 'nuxt_plugin_image_9ddbf228' // Source: ./image.js (mode: 'all')
import nuxt_plugin_unhead_07bcb4be from 'nuxt_plugin_unhead_07bcb4be' // Source: ../node_modules/@nuxt/bridge/dist/runtime/head/plugins/unhead (mode: 'all')
import nuxt_plugin_capiplugin_9e3ab2fc from 'nuxt_plugin_capiplugin_9e3ab2fc' // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_34ae9c67 from 'nuxt_plugin_errorpluginserver_34ae9c67' // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_00loggerclient_2112379c from 'nuxt_plugin_00loggerclient_2112379c' // Source: ../plugins/00.logger.client.ts (mode: 'client')
import nuxt_plugin_00loggerserver_f268adb8 from 'nuxt_plugin_00loggerserver_f268adb8' // Source: ../plugins/00.logger.server.ts (mode: 'server')
import nuxt_plugin_01sentryclient_4e0d254a from 'nuxt_plugin_01sentryclient_4e0d254a' // Source: ../plugins/01.sentry.client.ts (mode: 'client')
import nuxt_plugin_02shopbackendclient_0abae047 from 'nuxt_plugin_02shopbackendclient_0abae047' // Source: ../plugins/02.shop-backend.client.ts (mode: 'client')
import nuxt_plugin_03fetchRedirectsserver_579ebf2e from 'nuxt_plugin_03fetchRedirectsserver_579ebf2e' // Source: ../plugins/03.fetchRedirects.server.ts (mode: 'server')
import nuxt_plugin_goliathclient_cffddb24 from 'nuxt_plugin_goliathclient_cffddb24' // Source: ../plugins/goliath.client.ts (mode: 'client')
import nuxt_plugin_goliathserver_048af814 from 'nuxt_plugin_goliathserver_048af814' // Source: ../plugins/goliath.server.ts (mode: 'server')
import nuxt_plugin_storeinitserver_12d7c08e from 'nuxt_plugin_storeinitserver_12d7c08e' // Source: ../plugins/store-init.server.ts (mode: 'server')
import nuxt_plugin_offersinitserver_59f16a28 from 'nuxt_plugin_offersinitserver_59f16a28' // Source: ../plugins/offers-init.server.ts (mode: 'server')
import nuxt_plugin_featuresplugin_1e1df08d from 'nuxt_plugin_featuresplugin_1e1df08d' // Source: ../plugins/features-plugin (mode: 'all')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_flyoutclient_1a65dec5 from 'nuxt_plugin_flyoutclient_1a65dec5' // Source: ../plugins/flyout.client.ts (mode: 'client')
import nuxt_plugin_modalclient_59a0d96a from 'nuxt_plugin_modalclient_59a0d96a' // Source: ../plugins/modal.client.ts (mode: 'client')
import nuxt_plugin_jsonld_cea01772 from 'nuxt_plugin_jsonld_cea01772' // Source: ../plugins/json-ld (mode: 'all')
import nuxt_plugin_portal_4532993c from 'nuxt_plugin_portal_4532993c' // Source: ../plugins/portal (mode: 'all')
import nuxt_plugin_tealiumclient_0e5bd103 from 'nuxt_plugin_tealiumclient_0e5bd103' // Source: ../plugins/tealium.client.ts (mode: 'client')
import nuxt_plugin_componentlibrary_0c1b5196 from 'nuxt_plugin_componentlibrary_0c1b5196' // Source: ../plugins/component-library (mode: 'all')
import nuxt_plugin_trackingfbclient_36c4f320 from 'nuxt_plugin_trackingfbclient_36c4f320' // Source: ../plugins/tracking-fb.client.ts (mode: 'client')
import nuxt_plugin_vuetoucheventsclient_1f1f28a2 from 'nuxt_plugin_vuetoucheventsclient_1f1f28a2' // Source: ../plugins/vue-touch-events.client.js (mode: 'client')
import nuxt_plugin_screensize_2b079c21 from 'nuxt_plugin_screensize_2b079c21' // Source: ../plugins/screen-size.ts (mode: 'all')
import nuxt_plugin_reducedmotionclient_48c332ef from 'nuxt_plugin_reducedmotionclient_48c332ef' // Source: ../plugins/reduced-motion.client.ts (mode: 'client')
import nuxt_plugin_reducedmotionserver_a306b712 from 'nuxt_plugin_reducedmotionserver_a306b712' // Source: ../plugins/reduced-motion.server.ts (mode: 'server')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_56bb234a === 'function') {
    await nuxt_plugin_plugin_56bb234a(app.context, inject)
  }

  if (typeof nuxt_plugin_middleware_6dbf44f5 === 'function') {
    await nuxt_plugin_middleware_6dbf44f5(app.context, inject)
  }

  if (typeof nuxt_plugin_store_4aa841a6 === 'function') {
    await nuxt_plugin_store_4aa841a6(app.context, inject)
  }

  if (typeof nuxt_plugin_appplugin_d06cc13e === 'function') {
    await nuxt_plugin_appplugin_d06cc13e(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin_1833388e === 'function') {
    await nuxt_plugin_configplugin_1833388e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nitrobridgeserver_ad41c2ae === 'function') {
    await nuxt_plugin_nitrobridgeserver_ad41c2ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nitrobridgeclient_57ea5f31 === 'function') {
    await nuxt_plugin_nitrobridgeclient_57ea5f31(app.context, inject)
  }

  if (typeof nuxt_plugin_image_9ddbf228 === 'function') {
    await nuxt_plugin_image_9ddbf228(app.context, inject)
  }

  if (typeof nuxt_plugin_unhead_07bcb4be === 'function') {
    await nuxt_plugin_unhead_07bcb4be(app.context, inject)
  }

  if (typeof nuxt_plugin_capiplugin_9e3ab2fc === 'function') {
    await nuxt_plugin_capiplugin_9e3ab2fc(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_errorpluginserver_34ae9c67 === 'function') {
    await nuxt_plugin_errorpluginserver_34ae9c67(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_00loggerclient_2112379c === 'function') {
    await nuxt_plugin_00loggerclient_2112379c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_00loggerserver_f268adb8 === 'function') {
    await nuxt_plugin_00loggerserver_f268adb8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_01sentryclient_4e0d254a === 'function') {
    await nuxt_plugin_01sentryclient_4e0d254a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_02shopbackendclient_0abae047 === 'function') {
    await nuxt_plugin_02shopbackendclient_0abae047(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_03fetchRedirectsserver_579ebf2e === 'function') {
    await nuxt_plugin_03fetchRedirectsserver_579ebf2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_goliathclient_cffddb24 === 'function') {
    await nuxt_plugin_goliathclient_cffddb24(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_goliathserver_048af814 === 'function') {
    await nuxt_plugin_goliathserver_048af814(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_storeinitserver_12d7c08e === 'function') {
    await nuxt_plugin_storeinitserver_12d7c08e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_offersinitserver_59f16a28 === 'function') {
    await nuxt_plugin_offersinitserver_59f16a28(app.context, inject)
  }

  if (typeof nuxt_plugin_featuresplugin_1e1df08d === 'function') {
    await nuxt_plugin_featuresplugin_1e1df08d(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flyoutclient_1a65dec5 === 'function') {
    await nuxt_plugin_flyoutclient_1a65dec5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modalclient_59a0d96a === 'function') {
    await nuxt_plugin_modalclient_59a0d96a(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_cea01772 === 'function') {
    await nuxt_plugin_jsonld_cea01772(app.context, inject)
  }

  if (typeof nuxt_plugin_portal_4532993c === 'function') {
    await nuxt_plugin_portal_4532993c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tealiumclient_0e5bd103 === 'function') {
    await nuxt_plugin_tealiumclient_0e5bd103(app.context, inject)
  }

  if (typeof nuxt_plugin_componentlibrary_0c1b5196 === 'function') {
    await nuxt_plugin_componentlibrary_0c1b5196(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackingfbclient_36c4f320 === 'function') {
    await nuxt_plugin_trackingfbclient_36c4f320(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoucheventsclient_1f1f28a2 === 'function') {
    await nuxt_plugin_vuetoucheventsclient_1f1f28a2(app.context, inject)
  }

  if (typeof nuxt_plugin_screensize_2b079c21 === 'function') {
    await nuxt_plugin_screensize_2b079c21(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_reducedmotionclient_48c332ef === 'function') {
    await nuxt_plugin_reducedmotionclient_48c332ef(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_reducedmotionserver_a306b712 === 'function') {
    await nuxt_plugin_reducedmotionserver_a306b712(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
